// You still need to register Vuetify itself
// src/plugins/vuetify.js

import Vue from 'vue'
import 'normalize.css/normalize.css'

import '@mdi/font/css/materialdesignicons.css'
// import 'material-design-icons.css'
import Vuetify, {
  VMain,
  VAppBar,
  VScaleTransition,
  VSlideItem,
  VSlideGroup,
  VListItemAvatar,
  VAvatar,
  VAutocomplete,
  VTaber,
  VResponsive,
  VItem,
  VItemGroup,
  VSheet,
  VRadioGroup,
  VRadio,
  VCombobox,
  VContainer,
  VApp,
  VCard,
  VNavigationDrawer,
  VList,
  VDivider,
  VListItem,
  VListItemContent,
  VListItemTitle,
  VListItemSubtitle,
  VListItemIcon,
  VIcon,
  VListGroup,
  VListItemAction,
  VColorPicker,
  VPagination,
  VTab,
  VTabs,
  VDatePicker,
  VTreeview,
  VBreadcrumbs,
  VSelect,
  VSimpleTable,
  VMenu,
  VBtn,
  VDialog,
  VCardTitle,
  VCardText,
  VCardActions,
  VSpacer,
  VInput,
  VTextField,
  VTabItem,
  VTabsItems,
  VSwitch,
  VRow,
  VCol,
  VCheckbox,
  VTextarea,
  VForm,
  VSnackbar,
  VCardSubtitle,
  VSkeletonLoader,
  VDataTable,
  VExpansionPanels,
  VExpansionPanel,
  VExpansionPanelHeader,
  VExpansionPanelContent,
  VFileInput,
  VImg,
  VStepper,
  VStepperHeader,
  VStepperStep,
  VStepperItems,
  VStepperContent,
  VOverlay,
  VTooltip,
  VChip,
  VExpandTransition,
  VHover,
  VProgressCircular,
  VChipGroup,
  VBadge
} from 'vuetify/lib'

Vue.use(Vuetify, {
  components: {
    VMain,
    VAppBar,
    VScaleTransition,
    VSlideItem,
    VSlideGroup,
    VBadge,
    VChipGroup,
    VListItemAvatar,
    VAvatar,
    VAutocomplete,
    VTaber,
    VResponsive,
    VItem,
    VItemGroup,
    VProgressCircular,
    VHover,
    VSheet,
    VExpandTransition,
    VChip,
    VTooltip,
    VRadioGroup,
    VRadio,
    VCombobox,
    VContainer,
    VStepperContent,
    VStepperItems,
    VStepperStep,
    VStepperHeader,
    VStepper,
    VApp,
    VCard,
    VNavigationDrawer,
    VList,
    VDivider,
    VListItem,
    VListItemContent,
    VListItemTitle,
    VListItemSubtitle,
    VListItemIcon,
    VIcon,
    VListGroup,
    VListItemAction,
    VColorPicker,
    VPagination,
    VTab,
    VTabs,
    VDatePicker,
    VTreeview,
    VBreadcrumbs,
    VSelect,
    VSimpleTable,
    VMenu,
    VBtn,
    VDialog,
    VCardTitle,
    VCardText,
    VCardActions,
    VSpacer,
    VInput,
    VTextField,
    VTabItem,
    VTabsItems,
    VSwitch,
    VRow,
    VCol,
    VCheckbox,
    VTextarea,
    VForm,
    VSnackbar,
    VCardSubtitle,
    VSkeletonLoader,
    VDataTable,
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelHeader,
    VExpansionPanelContent,
    VFileInput,
    VImg,
    VOverlay
  }
})
import "vuetify/dist/vuetify.min.css";

const opts = {
  breakpoint: { scrollbarWidth: 6 },
  theme: {
    themes: {
      light: {
        primary: '#0F46C1',
        // primary: '#ff8a00',
        // secondary: 'rgba(0,0,0,0.38)',
        // accent: '#9c27b0',
        // error: '#f44336',
        // warning: '#ff5722',
        // info: '#607d8b',
        // success: '#4caf50'
      }
    }
  },
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  // lang: {
  //   locales: { zhHans, en, ja, th },
  //   current: "zhHans"
  //   }
}

export default new Vuetify(opts)